import fetcher from '../../helpers/fetcher';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import { API_ENDPOINTS } from '../../constants/apiEndpoints';

export interface AlertConfig {
  id?: number;
  productRefId: string;
  triggeringCondition: 'manual_price' | 'average_price';
  fromDateRange?: number;
  toDateRange?: number;
  startMonitoringDateRange?: number;
  endMonitoringDateRange?: number;
  price?: number;
  avgPrice?: number;
  condition?: string;
  threshold?: number;
  numberOfInstance: number;
  locationId: number;
  enableAlert: boolean;
  createTime?: number;
  updateTime?: number;
  isActive?: boolean;
  userId?: number;
}

export interface CreateAlertConfigDto {
  productRefId: string;
  triggeringCondition: 'manual_price' | 'average_price';
  fromDateRange?: number;
  toDateRange?: number;
  startMonitoringDateRange?: number;
  endMonitoringDateRange?: number;
  price?: number;
  avgPrice?: number;
  condition?: string;
  threshold?: number;
  numberOfInstance: number;
  locationId: number;
  enableAlert: boolean;
  userId?: number;
}

export type UpdateAlertConfigDto = Partial<CreateAlertConfigDto>;

export interface QueryAlertConfigDto {
  productRefId?: string;
  triggeringCondition?: 'manual_price' | 'average_price';
  locationId?: number;
  enableAlert?: boolean;
  isActive?: boolean;
  userId?: number;
}

export interface AlertConfigResponse {
  data: AlertConfig[];
  total: number;
  page: number;
  limit: number;
}

export class AlertConfigService {
  private consumerPriceUrl = ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE;

  async createAlertConfig(createAlertConfigDto: CreateAlertConfigDto): Promise<AlertConfig> {
    const response = await fetcher.post(
      API_ENDPOINTS.ALERT_CONFIG.ALERT_CONFIGS,
      createAlertConfigDto,
      undefined,
      this.consumerPriceUrl
    );
    return response.data as AlertConfig;
  }

  async getAlertConfigs(query: QueryAlertConfigDto = {}): Promise<AlertConfig[]> {
    const queryParams = new URLSearchParams();


    if (query.productRefId) queryParams.append('productRefId', query.productRefId);
    if (query.triggeringCondition)
      queryParams.append('triggeringCondition', query.triggeringCondition);
    if (query.locationId) queryParams.append('locationId', query.locationId.toString());
    if (query.enableAlert !== undefined)
      queryParams.append('enableAlert', query.enableAlert.toString());
    if (query.isActive !== undefined) queryParams.append('isActive', query.isActive.toString());
    if (query.userId) queryParams.append('userId', query.userId.toString());

    const response = await fetcher.get(
      API_ENDPOINTS.ALERT_CONFIG.GET_ALERT_CONFIG_LIST,
      queryParams,
      undefined,
      this.consumerPriceUrl
    );
    return response.data as AlertConfig[];
  }

  async updateAlertConfig(
    id: number,
    updateAlertConfigDto: UpdateAlertConfigDto
  ): Promise<AlertConfig> {
    const response = await fetcher.patch(
      `${API_ENDPOINTS.ALERT_CONFIG.ALERT_CONFIGS}/${id}`,
      updateAlertConfigDto,
      undefined,
      this.consumerPriceUrl
    );
    return response.data as AlertConfig;
  }

  async deleteAlertConfig(id: number): Promise<void> {
    await fetcher.del(
      `${API_ENDPOINTS.ALERT_CONFIG.ALERT_CONFIGS}/${id}`,
      undefined,
      undefined,
      this.consumerPriceUrl
    );
  }
}

export const alertConfigService = new AlertConfigService();
